import { useCallback } from 'react'
import Pane from 'components/Common/Pane'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Heading from 'LuxKit/Typography/Heading'
import TextInput from 'components/Common/Form/Input/TextInput'
import LineArrowRightIcon from 'LuxKit/Icons/line/LineArrowRightIcon'
import { formToObject } from 'lib/forms/formToObject'
import Clickable from 'components/Common/Clickable'
import { setAuthTokenToCookies } from 'api/auth'
import { useIntl } from 'react-intl'

function AuthTab() {
  const intl = useIntl()
  const onSetAccessToken = useCallback<React.FormEventHandler<HTMLFormElement>>(e => {
    e.preventDefault()
    const { accessToken } = formToObject(e.currentTarget)
    if (accessToken) {
      (e.currentTarget.elements.namedItem('accessToken') as HTMLInputElement).value = ''
      setAuthTokenToCookies(accessToken)
      window.location.reload()
    }
  }, [])

  return <Pane padding={20}>
    <VerticalSpacer gap={16}>
      <Heading variant="heading5">{intl.formatMessage({
        id: 'temp_dev_panel_auth_heading',
        defaultMessage: 'Auth',
        description: 'Heading for the authentication tools tab in the customer portal developer tools panel',
      })}
      </Heading>

      <form onSubmit={onSetAccessToken}>
        <TextInput
          label={intl.formatMessage({
            id: 'temp_dev_panel_set_access_token_label',
            defaultMessage: 'Set access token',
            description: 'Input label for manually setting an access token in the customer portal developer tools panel',
          })}
          helpText={intl.formatMessage({
            id: 'temp_dev_panel_set_access_token_help_text',
            defaultMessage: 'Useful for logging into prod via local CP. Will reload the page.',
            description: 'Help text explaining the effect of manually setting an access token in the customer portal developer tools panel',
          })}
          name="accessToken"
          required
          endIcon={<Clickable type="submit"><LineArrowRightIcon /></Clickable>}
        />
      </form>
    </VerticalSpacer>
  </Pane>
}

export default AuthTab
